import { __assign, __rest } from "tslib";
import React from 'react';
import { applyDisplayName } from '../internal/utils/apply-display-name.js';
import useBaseComponent from '../internal/hooks/use-base-component';
import InternalBreadcrumbGroup from './internal';
export default function BreadcrumbGroup(_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, props = __rest(_a, ["items"]);
    var baseComponentProps = useBaseComponent('BreadcrumbGroup');
    return React.createElement(InternalBreadcrumbGroup, __assign({ items: items }, props, baseComponentProps));
}
applyDisplayName(BreadcrumbGroup, 'BreadcrumbGroup');
//# sourceMappingURL=index.js.map